import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_ACTIVE_TEAMS } from '../../graphql/teams';
import { TEAM_DEPARTMENTS } from '../team-members/teams-constants';
import { getPropertyManagerDisplayName } from '../../utils/propertyManagers';

export default function PropertyManagementFilter({
  id,
  value,
  onChange,
  users = [],
  className = 'w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm',
}) {
  const { data: teamsData } = useQuery(GET_ACTIVE_TEAMS, {
    variables: { department: TEAM_DEPARTMENTS.PROPERTY_MANAGEMENT },
  });
  const teams = teamsData?.activeTeams || [];

  return (
    <select
      id={id}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className={className}
    >
      <option value="">All property managers</option>
      {teams.length > 0 && (
        <optgroup label="Teams">
          {teams.map((team) => (
            <option key={`team-${team.id}`} value={`team:${team.id}`}>{team.name}</option>
          ))}
        </optgroup>
      )}
      {users.length > 0 && (
        <optgroup label="People">
          {users.map((user) => (
            <option key={`user-${user.id}`} value={`user:${user.id}`}>
              {getPropertyManagerDisplayName(user) || user.email}
            </option>
          ))}
        </optgroup>
      )}
    </select>
  );
}
